import type { AnimalCollectionItem } from '@nuxt/content'

export default async function () {
  return useAsyncData('animals', async () => {
    return queryCollection('animal').order('name', 'ASC').all()
  }, {
    default(): AnimalCollectionItem[] {
      return []
    },
  })
}
